/** Typeface identifiers accepted in brand records. Raw bundles choose their own font assets. */
export const TYPEFACES = {
    editorial: true,
    classic: true,
    literary: true,
    modern: true,
    geometric: true,
    friendly: true,
    statement: true,
};
